var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ioc-tab-group"},[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.option.column),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"name":index.toString(),"label":item.label}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }